import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { Typography } from "antd";
import { importClientHistory } from "store/clients";
import CustomPagination from "components/common/CustomPagination";
import DataTable from "ui/DataTable";

const ViewImportHistory = () => {
    const dispatch = useDispatch()
    const { importClientHistoryData } = useSelector((state) => state.clients)
    const [sortKey, setSortKey] = useState('')
    const [sortOrder, setSortOrder] = useState('')
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(10)
    const dataSource = importClientHistoryData?.data?.map((item) => ({
        key: item.id,
        status: item.status,
        filename: item.filename,
        started_at: item.started_at,
        completed_at: item.completed_at,
        file_url: item.file_url,
        report_url: item.report_url
    }))

    const metadata = importClientHistoryData?.metadata

    const onSortChange = ({ field, order }) => {
        setSortKey(field)
        setSortOrder(order)
    }

    const getHeaders = ({ field, order }) => [
        {
            title: 'Filename',
            dataIndex: 'filename',
            key: 'filename',
            sorter: true,
            sortOrder: field === 'filename' ? order : null,
            render: (text, record) => (
                <a href={record.file_url} target="_blank" rel="noopener noreferrer">
                    {text}
                </a>
            ),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
        },
        {
            title: 'Started At',
            dataIndex: 'started_at',
            key: 'started_at',
            render: (val) => val ? dayjs(val)?.format('YYYY-MM-DD HH:mm:ss') : "",
        },
        {
            title: 'Completed At',
            dataIndex: 'completed_at',
            key: 'completed_at',
            render: (val) => val ? dayjs(val)?.format('YYYY-MM-DD HH:mm:ss') : "",
        },
        {
            title: 'Download Report',
            dataIndex: 'report_url',
            key: 'report_url',
            sorter: true,
            ellipsis: true, // <-- IMPORTANT

            render: (text, record) =>
                record?.report_url ? (
                    <Typography.Text ellipsis={{ tooltip: text }}>
                        <a href={record?.report_url} target="_blank" rel="noopener noreferrer">
                            {"report.json"}
                        </a>
                    </Typography.Text>
                ) : (
                    ""
                ),
        },
    ]

    useEffect(() => {
        dispatch(importClientHistory({ page, pageSize }));
    }, [page, pageSize]);


    return (
        <div>
            <DataTable
                columns={getHeaders({ field: sortKey, order: sortOrder })}
                dataSource={dataSource}
                pagination={false}
                rowClickKey="key"
                onChange={onSortChange}
                rowSelection={false}
                rowKey={(record) => record.key}
            />
            {metadata?.total_results > 10 && (
                <div className="mb-m">
                    <CustomPagination
                        metadata={metadata}
                        pageSize={pageSize}
                        total={metadata?.total_results || 0}
                        onPageChange={setPage}
                        onPageSizeChange={(newSize) => {
                            setPageSize(newSize);
                            setPage(1);
                        }}
                    />
                </div>
            )}
        </div>
    )
}

export default ViewImportHistory